import {httpClientV2} from "../../../../infrastructure/http";
import {
  PaginatedPastCalls,
  PaginationParams,
  PastCallsRepository,
} from "../../domain/types";
import {PastCallsMapperV2} from "../mappers/mapper.v2";
import {V2PastCallsResponse} from "../mappers/mapper.types";

/**
 * v2 API implementation of PastCallsRepository.
 *
 * Endpoint: GET bookings/past?page={page}&perPage={perPage}
 * Response: { status, message, data: { data: [...], total, hasNextPage, hasPrevPage } }
 *
 * Pure TypeScript - no React imports.
 */
export class PastCallsRepositoryV2 implements PastCallsRepository {
  private readonly endpoint = "bookings/past";

  async getCoachPastCalls(params?: PaginationParams): Promise<PaginatedPastCalls> {
    // v2 uses camelCase `perPage` (v1 used `per_page`).
    const queryParams = new URLSearchParams();
    if (params?.page !== undefined) {
      queryParams.append("page", params.page.toString());
    }
    if (params?.perPage !== undefined) {
      queryParams.append("perPage", params.perPage.toString());
    }

    const queryString = queryParams.toString();
    const url = queryString ? `${this.endpoint}?${queryString}` : this.endpoint;

    const response = await httpClientV2.get<V2PastCallsResponse>(url);
    return PastCallsMapperV2.toPaginated(response.data);
  }
}
